import { useState, useEffect } from 'react';

function ProtectedPage() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [data, setData] = useState(null);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const fetchProtectedData = async (jwt) => {
    try {
      const res = await fetch('https://iittp.ac.in/jwt/protected.php', {
        headers: { Authorization: `Bearer ${jwt}` },
      });

      if (!res.ok) throw new Error("Unauthorized");

      const result = await res.json();
      setData(result.data);
    } catch {
      setToken(null);
      setData(null);
      localStorage.removeItem('token');
    }
  };

  useEffect(() => {
    if (token) {
      fetchProtectedData(token);
    }
  }, [token]);

  const handleLogin = async () => {
    setError('');
    const res = await fetch('https://iittp.ac.in/jwt/login.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    });

    const result = await res.json();
    if (result.token) {
      localStorage.setItem('token', result.token);
      setToken(result.token);
    } else {
      setError(result.message || 'Login failed');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setData(null);
  };

  return (
    <div className="p-4 max-w-md mx-auto">
      {token && data ? (
        <>
          <h1 className="text-2xl font-bold mb-4">🔐 Protected Content</h1>
          <p>{data}</p>
          <button className="mt-4 bg-red-500 text-white px-4 py-2" onClick={handleLogout}>
            Logout
          </button>
        </>
      ) : (
        <>
          <h2 className="text-xl font-bold mb-4">🔓 Please Log In</h2>
          <input
            className="border w-full mb-2 p-2"
            type="text"
            placeholder="Username"
            onChange={(e) => setUsername(e.target.value)}
          />
          <input
            className="border w-full mb-2 p-2"
            type="password"
            placeholder="Password"
            onChange={(e) => setPassword(e.target.value)}
          />
          <button className="bg-blue-600 text-white px-4 py-2" onClick={handleLogin}>
            Login
          </button>
          {error && <p className="text-red-500 mt-2">{error}</p>}
        </>
      )}
    </div>
  );
}

export default ProtectedPage;
